module.exports = __webpack_public_path__ + "img/overview-aml.2fe3a68a.png";